import UserManagementContainer from "../../container/admin/userManagement/userManagementContainer";

const UserManagement = (): React.JSX.Element => <UserManagementContainer />;

export default UserManagement;
